// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home-sec-4 .img-popup {
    position: fixed;
    z-index: 999;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 0;
    width: 0;
    opacity: 0;
    transition: all ease 0.9s;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .home-sec-4 .img-popup.show {
    opacity: 1;
    max-height: calc(100vh - 20px);
    width: fit-content;
    height: fit-content;
    left: 50%; 
    transition: all ease 0.9s;
    
  }
  
  .home-sec-4 .img-popup img {
    border-radius: 10px;
    object-fit: contain;
    max-height: calc(100vh - 140px); 
    max-width: calc(100vw - 500px);
    width: auto;
    height: auto;
  }
  .home-sec-4 .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 24px;
    height: 24px;
    fill: #fff;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.918));
    cursor: pointer;
  }
  .home-sec-4 img{
    margin-bottom: 0 !important;
  }


@media (min-width:768px) and (max-width:992px) {
  .home-sec-4 .img-popup img{
    max-width: calc(100vw - 100px);
  }
  .home-sec-4 .card .line{
    position: static;
    width: 130px;
  }
  .home-sec-4 .card .box{
    background:none !important;
  }
}

@media (max-width:576px){
  .home-sec-4 .card .box{
    background: none !important;
  }
  /* .home-sec-4 .card .line{
    position: static;
    width: 130px;
    left: 0;
  } */
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Home/HomeGallery.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,yBAAyB;;EAE3B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,8BAA8B;IAC9B,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,qDAAqD;IACrD,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;;;AAGF;EACE;IACE,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;;;;KAIG;AACL","sourcesContent":["\r\n.home-sec-4 .img-popup {\r\n    position: fixed;\r\n    z-index: 999;\r\n    top: 55%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    height: 0;\r\n    width: 0;\r\n    opacity: 0;\r\n    transition: all ease 0.9s;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .home-sec-4 .img-popup.show {\r\n    opacity: 1;\r\n    max-height: calc(100vh - 20px);\r\n    width: fit-content;\r\n    height: fit-content;\r\n    left: 50%; \r\n    transition: all ease 0.9s;\r\n    \r\n  }\r\n  \r\n  .home-sec-4 .img-popup img {\r\n    border-radius: 10px;\r\n    object-fit: contain;\r\n    max-height: calc(100vh - 140px); \r\n    max-width: calc(100vw - 500px);\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n  .home-sec-4 .close-icon {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    width: 24px;\r\n    height: 24px;\r\n    fill: #fff;\r\n    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.918));\r\n    cursor: pointer;\r\n  }\r\n  .home-sec-4 img{\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n\r\n@media (min-width:768px) and (max-width:992px) {\r\n  .home-sec-4 .img-popup img{\r\n    max-width: calc(100vw - 100px);\r\n  }\r\n  .home-sec-4 .card .line{\r\n    position: static;\r\n    width: 130px;\r\n  }\r\n  .home-sec-4 .card .box{\r\n    background:none !important;\r\n  }\r\n}\r\n\r\n@media (max-width:576px){\r\n  .home-sec-4 .card .box{\r\n    background: none !important;\r\n  }\r\n  /* .home-sec-4 .card .line{\r\n    position: static;\r\n    width: 130px;\r\n    left: 0;\r\n  } */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
